import { useEffect, useState } from 'react';
import { QuerySuggestionResponse } from '../@types/QuerySuggestion';
import { PublicApiSettings } from '../Gql/config';
import { fetchSuggestions } from '../Gql/suggest';
import useFetch from './useFetch';

interface SuggestionState {
  loading: boolean;
  error: boolean;
  response?: QuerySuggestionResponse;
}

/**
 * Typeahead suggestions for a search bar. With `publicApi` they come from
 * `search.ads(q).suggest`, otherwise from the legacy query-suggestion service.
 */
const useQuerySugesstion = (url: string, query: string, publicApi?: PublicApiSettings) => {
  const skip = query.length < 2;
  const legacy = useFetch<QuerySuggestionResponse>(
    `${url}${query ? `?q=${query}` : ''}`,
    {},
    skip || !!publicApi
  );
  const [gql, setGql] = useState<SuggestionState>({ loading: false, error: false });

  useEffect(() => {
    if (!publicApi || skip) return;
    let active = true;
    setGql((s) => ({ ...s, loading: true, error: false }));
    fetchSuggestions(publicApi, query)
      .then((response) => active && setGql({ loading: false, error: false, response }))
      .catch(() => active && setGql({ loading: false, error: true }));
    return () => {
      active = false;
    };
  }, [query, skip, publicApi?.branchGroupId, publicApi?.api.url]);

  if (publicApi) {
    return { ...gql, response: skip ? undefined : gql.response };
  }

  return {
    loading: legacy.loading,
    error: legacy.error,
    response: skip ? undefined : legacy.data,
  };
};

export default useQuerySugesstion;
